import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moduleCompany from "@/store/company/moduleCompany.js";
import CellRendererUnlimited from "@/components/optimizer-manager/list/cell-renderer/CellRendererUnlimited.vue";
import CellRendererStatus from "@/components/optimizer-manager/list/cell-renderer/CellRendererStatus.vue";
import CellRendererService from "@/components/optimizer-manager/list/cell-renderer/CellRendererService.vue";
import CellRendererActions from "@/components/optimizer-manager/list/cell-renderer/CellRendererActions.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const optimizerManagerListMixin = {
	name: "OptimizerManagerList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
					showActions: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		status_id: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererUnlimited,
		CellRendererStatus,
		CellRendererActions,
		CellRendererService,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			searchQuery: [],
			searchList: [],
			dataSelected: null,
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Id",
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererUnlimited,
				CellRendererStatus,
				CellRendererActions,
				CellRendererService,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("typology_name", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status_name", obj.value);
		},
		isVerifiedFilter(obj) {
			let val = "";
			if (obj.value === "all") {
				val = "all";
			} else if (obj.value === "yes") {
				val = "true";
			} else {
				val = "false";
			}
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		currentPageLocal(page) {
			this.getManagerOptimizer(page);
		},
		quantityElementPage() {
			this.getManagerOptimizer(1);
		},
		searchField(val) {
			if (val === "Company") {
				this.$store
					.dispatch("moduleCompany/fetchDataListItems")
					.then((res) => {
						this.getSearch(res.data);
					})
					.catch((err) => {
						console.error(err);
					});
			} else if (val === "Optimizer") {
				const optimizerList = [
					{name: "OPENROUTE", id: "OPENROUTE"},
					{name: "GMPRO", id: "GMPRO"},
					{name: "TOUR PLANNING", id: "TOUR_PLANNING"},
					{name: "SERVIROUTES", id: "SERVIROUTES"},
				];
				this.getSearch(optimizerList);
			}
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 150,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
					cellRendererFramework: this.customConfig.activeLink ? "CellRendererLink" : null,
					pinned: this.customConfig.activeCheckbox ? "left" : "",
				},
				{
					headerName: this.$t("Routing.Optimizer"),
					field: "optimization_api",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("Company"),
					field: "company_name",
					filter: filterHead,
					width: 350,
				},
				{
					headerName: this.$t("TypeOfService"),
					field: "service",
					filter: filterHead,
					cellRendererFramework: "CellRendererService",
					width: 250,
				},
				{
					headerName: this.$t("OptimizerManager.PointsPerDay"),
					field: "points_per_day",
					cellRendererFramework: "CellRendererUnlimited",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("OptimizerManager.PointsPerWeek"),
					field: "points_per_week",
					cellRendererFramework: "CellRendererUnlimited",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("OptimizerManager.PointsPerMonth"),
					field: "points_per_month",
					cellRendererFramework: "CellRendererUnlimited",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("OptimizerManager.PointsSubscriptionMonthly"),
					field: "points_subscription_monthly",
					cellRendererFramework: "CellRendererUnlimited",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("OptimizerManager.PointsTotal"),
					field: "points_total",
					cellRendererFramework: "CellRendererUnlimited",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("SessionApi.ExpireDate"),
					field: "added_on",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		isWidthPortatil() {
			return window.innerWidth <= 1966;
		},
		optimizerManagerData() {
			return this.$store.state.optimizerManager.optimizerManagerList;
		},
	},
	methods: {
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		getManagerOptimizer(page) {
			this.onBtShowLoading();
			const payload = {
				sort: "desc",
				page,
				quantity: this.quantityElementPage,
				match_filter: true,
				status_id: this.status_id,
				order_by: ["id"],
			};
			this.$store
				.dispatch("optimizerManager/optimizerManagerFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchOptimizerManager() {
			const searchQueryList = this.searchQuery.map(({value}) => Number(value));
			const dataPage = {
				id: this.searchField === "Id" ? searchQueryList : [],
				optimization_api: this.searchField === "Optimizer" ? this.dataSelected.map(({value}) => value) : [],
				company_id: this.searchField === "Company" ? this.dataSelected.map(({value}) => value) : [],
				status_id: this.status_id,
				match_filter: true,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("optimizerManager/optimizerManagerFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refreshOptimizerManager() {
			this.dataSelected = null;
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.getManagerOptimizer(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		getSearch(data) {
			this.searchList = [];
			this.searchList = data.map((info) => {
				return {label: info.name, value: info.id};
			});
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		this.$emit("gridApiEmit", this.gridApi);
		this.getManagerOptimizer(1);
	},
	created() {
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
	},
};
